import React, {useState} from 'react';
import LeftBar from "../../components/left-bar/LeftBar";
import NavigationLinks from "../../components/navigation-links/NavigationLinks";
import Content from "../../components/content/Content";
import DataTable from "../../components/data-table/DataTable";
import {useTranslation} from "react-i18next";
import _ from "lodash";
import {getMegafonMessages} from "../../services/megafon";
import {navLinks} from "./MegafonView";
import ActionButton from "../../components/button/ActionButton";
import DateField from "../../components/fields/DateField";
import moment from "moment";
import XLSX from "xlsx";

const columnData = [
    { id: 'phone', numeric: false, disablePadding: false, label: 'Phone' },
    { id: 'dateCreated', label: 'Date created', dateFormat: "DD.MM.YYYY" },
    { id: 'actualSendDate', label: 'Date send', dateFormat: "DD.MM.YYYY HH:mm:ss" },
    { id: 'message', numeric: false, disablePadding: false, label: 'Message' },
    {
        id: 'additionalParameters',
        label: 'Parameters',
        numeric: false,
        processValue: (data) => {
            let returnData = [];

            if (_.size(data) > 0) {
                _.forEach(data, (el, i) => {
                    returnData.push(<p key={`${i}_${el}`}>{`${i} : ${el}`}</p>);
                })
            }

            return returnData;
        }
    },
    { id: 'messageSendStatus', numeric: false, disablePadding: false, label: 'Status' },
    { id: 'messageType', numeric: false, disablePadding: false, label: 'Type' },
    { id: 'messageConnectInitiator', numeric: false, disablePadding: false, label: 'Initiator' },
];

const columnDataXlsx = [
    { id: 'phone', label: 'Phone' },
    { id: 'dateCreated', label: 'Date created', dateFormat: "DD.MM.YYYY HH:mm:ss" },
    { id: 'actualSendDate', label: 'Date send', dateFormat: "DD.MM.YYYY HH:mm:ss" },
    { id: 'message', label: 'Message' },
    { id: 'messageSendStatus', label: 'Status' },
    { id: 'messageType', label: 'Type' },
    { id: 'messageConnectInitiator', label: 'Initiator' },
];

export default function MegafonMessagesPage() {

    const { t } = useTranslation();
    const loading = true;
    const [tableDataParameters, setTableDataParameters] = useState({
        filterDateStart: null,
        filterDateStop: null,
    });
    const [canGetData, setCanGetData] = useState(false);
    const [tableKey, setTableKey] = useState(0);
    const [shouldLoadData, setShouldLoadData] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const handleTableDataParametersDateChange = prop => date => {
        const newState = {
            ...tableDataParameters,
            [prop]: date
        };

        setTableDataParameters(newState);
        setShouldLoadData(false);

        if (
            newState.filterDateStart &&
            newState.filterDateStop
        ) {
            setCanGetData(true);
        } else {
            setCanGetData(false);
        }
    };

    const getTableData = (page, per_page, order, order_by) => {

        return getMegafonMessages(
            page,
            per_page,
            order,
            'actualSendDate',
            tableDataParameters
        );
    };

    const loadData = () => {
        setShouldLoadData(true);
        setTableKey(prev => prev + 1);
    };

    const handleExport = () => {
        setExportLoading(true);
        getMegafonMessages(
            1,
            -1,
            'desc',
            'actualSendDate',
            tableDataParameters
        ).then(response => {

            if (!response.success) {
                return;
            }

            const data = [
                columnDataXlsx.map(col => t(col.label))
            ];
            response.data.forEach(row => {
                data.push(
                    columnDataXlsx.map(col => {
                        let value = _.get(row, col.id);

                        if (col.dateFormat && value) {
                            return moment(value).format(col.dateFormat);
                        }

                        return value ?? '';
                    })
                );
            });

            const worksheet = XLSX.utils.aoa_to_sheet(data);
            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Megafon messages');
            XLSX.writeFile(workbook, `megafon_messages_${moment().format('YYYY_MM_DD_HH_mm')}.xlsx`);
        })
            .finally(() => {setExportLoading(false);});
    };

    return (
        <>
            <LeftBar navigationLinks={<NavigationLinks links={navLinks}/>}>
                <DateField
                    label={t('Date start')}
                    value={tableDataParameters.filterDateStart}
                    onChange={handleTableDataParametersDateChange('filterDateStart')}
                    fullWidth
                    disabled={!loading}
                />
                <DateField
                    label={t('Date stop')}
                    value={tableDataParameters.filterDateStop}
                    onChange={handleTableDataParametersDateChange('filterDateStop')}
                    fullWidth
                    disabled={!loading}
                />
                <ActionButton disabled={!loading || !canGetData} onClick={loadData}>{t("Get data")}</ActionButton>
                <ActionButton disabled={!loading || exportLoading || !canGetData} onClick={handleExport}>{t("Export to Excel")}</ActionButton>
            </LeftBar>
            <Content title={t("Messages")}>
                <DataTable
                    key={tableKey}
                    columnData={columnData}
                    dataFunc={shouldLoadData ? getTableData : () => Promise.resolve({data: [], total: 0})}
                    selector={false}
                />
            </Content>
        </>
    )
}